<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">

        <template v-if="siteDetails && Object.keys(siteDetails).length">
          <p class="text-muted">Ваш выбор покажет препараты с не заполнеными характеристиками</p>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="">Выберите характеристики для поиска</label>
                <multiselect
                  class=""
                  v-model="filter.selectedOptions"
                  :options="Object.values(siteDetails)"
                  :multiple="true"
                  @input="checkSelectedDetails"
                  label="title"
                  track-by="title"
                  placeholder="Выберите характеристики"
                  select-label="Выбрать"
                  deselect-label="Убрать характеристику">
                </multiselect>
              </div>
            </div>
            <div class="col-md-6">

            </div>
            <div class="col-md-12 text-right">
              <LoadingButton
                title="Показать"
                :loading="btnLoading"
                type="button"
                :color="$constants.SUCCESS_COLOR"
                :onClick="() => getRecords()"
                className="btn btn-outline-success"
              />
            </div>
          </div>

        </template>

        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>

        <template v-if="!loading && records">
          <table class="table mt-1 table-hover table-sm">
            <thead>
            <tr>
              <th rowspan="2"></th>
              <th rowspan="2">ID</th>
              <th rowspan="2">Препарат</th>
              <th :colspan="$AllProjects.length">Проекты</th>
              <th rowspan="2"></th>
            </tr>
            <tr>
              <th v-for="p in $AllProjects">
                {{ p.title }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(r,i) in records">
              <td>{{ (i + 1) + ((paginator.current_page - 1) * paginator.per_page) }}</td>
              <td>{{ r.id }}</td>
              <td>{{ r.title }}</td>
              <td v-for="p in $AllProjects" class="text-center">
                <template v-if="r.siteActive[p.id]">
                  <button
                    @click="editDrug(r.id, p.id)"
                    :class="{
                      'btn btn-xs': true,
                      'btn-default': filter.selectedOptions.length === 1 && !drugSiteFields[p.id][filter.selectedOptions[0].id],
                      'btn-info': !r.projectMissed[p.id],
                      'btn-warning':r.projectMissed[p.id]
                    }"
                  >
                    <i class="icon-fa icon-fa-eye"></i>
                  </button>
                </template>
                <template v-else>
                  <i class="icon-fa icon-fa-remove"/>
                </template>
              </td>
              <td></td>
            </tr>
            </tbody>
          </table>

          <div class="text-right">
            <paginate v-if="paginator"
                      v-model="paginator.current_page"
                      :page-count="paginator.last_page"
                      ref="Pagination"
                      :page-range="11"
                      :margin-pages="2"
                      :click-handler="getRecords"
                      :prev-text="'&laquo'"
                      :next-text="'&raquo'"
                      :container-class="'pagination'"
                      :prev-class="'page-item'"
                      :prev-link-class="'page-link'"
                      :page-class="'page-item'"
                      :page-link-class="'page-link'"
                      :next-class="'page-item'"
                      :next-link-class="'page-link'"
                      :active-class="'active green_btn'">
            </paginate>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import Paginate from 'vuejs-paginate'
import Multiselect from 'vue-multiselect'
import LoadingButton from "@/components/buttons/LoadingButton.vue";


export default {
  components: {
    LoadingButton,
    Paginate,
    Multiselect,
  },
  created() {
    this.getRecords()
  },
  data() {
    return {
      loading: false,
      btnLoading: false,
      records: null,
      paginator: null,
      siteDetails: [],
      drugSiteFields: {},
      // baseDetailsIds: [3, 16, 20, 23, 22, 24, 25, 26, 42, 41],
      baseDetailsIds: [3, 16, 20, 23, 22, 24, 25, 26],
      filter: {
        selectedOptions: [],
      }
    }
  },
  computed: {
    $AllProjects() {
      const stores = this.$store.getters['platform/projects'].filter((s) => s.id && ![4, 7, 13].includes(s.id) && s.is_active)
      return _.orderBy(stores, 'id');
    },
  },
  methods: {
    checkSelectedDetails() {
      // const added = this.filter.selectedOptions[this.filter.selectedOptions.length - 1];
      // if (added && !added.id) {
      //   this.filter.selectedOptions = [{title: 'Проверить все детали'}];
      // } else {
      //   this.filter.selectedOptions = this.filter.selectedOptions.filter((s) => s.id);
      // }
    },
    editDrug(drugId, projectId) {
      this.$store.dispatch('platform/setGlobalDrawerData', {
        data: {type: 'drugEditSite', drugId, projectId},
      });
    },
    async getRecords(page = 1) {
      this.loading = true;
      this.btnLoading = true;
      let {data: r_data} = await api.post('/new/drugs/details/list', {
        page,
        filter: this.filter,
        siteDetails: !this.siteDetails.length
      })
      if (r_data.success) {
        const {data, ...pagination} = r_data.records
        this.paginator = pagination;

        const checkFilter = this.filter.selectedOptions.length ? this.filter.selectedOptions.map((d) => d.id) : [...this.baseDetailsIds];
        // console.log(checkFilter);

        this.records = data.reduce((acc, d) => {
          const r = {
            ...d,
            siteActive: d.prices.reduce((accp, p) => {
              if (p.qty === 1 && p.is_active) {
                accp[p.site_id] = true;
              }
              return accp;
            }, {}),
            siteDetailsSorted: d.site_details.reduce((accd, dd) => {
              if (!accd[dd.site_id]) accd[dd.site_id] = {};
              accd[dd.site_id][dd.detail_id] = {...dd, value: dd[dd.type + '_value']};
              return accd;
            }, {})
          };
          r.projectMissed = this.$AllProjects.reduce((accp, p) => {
            // console.log(checkFilter, p.id, r.siteDetailsSorted[p.id]);
            accp[p.id] = !checkFilter.every((val) => r.siteDetailsSorted[p.id] && r.siteDetailsSorted[p.id][val] && r.siteDetailsSorted[p.id][val].value);
            return accp;
          }, {})
          acc.push(r);
          return acc;
        }, []);

        if (r_data.siteDetails) {
          this.siteDetails = r_data.siteDetails.reduce((acc, d) => {
            if (this.baseDetailsIds.includes(d.id)) {
              acc[d.id] = d;
            }
            return acc;
            // }, {0: {title: 'Проверить все детали'}});
          }, {});
        }
        if (r_data.drugSiteFields) {
          this.drugSiteFields = r_data.drugSiteFields.reduce((acc, f) => {
            if (!this.baseDetailsIds.includes(f.detail_id)) return acc;
            if (!acc[f.site_id]) acc[f.site_id] = {};
            acc[f.site_id][f.detail_id] = true;
            return acc;
          }, {});
        }
      }
      this.btnLoading = false;
      this.loading = false;
    }
  }
}

</script>

<style scoped>
.btn.btn-xs.btn-default {
  color: #212529;
  border: 1px solid #ddd;
  background-color: #fff;
}

</style>
